import { render, staticRenderFns } from "./PoliticsList.vue?vue&type=template&id=4510be06&scoped=true&"
import script from "./PoliticsList.vue?vue&type=script&lang=js&"
export * from "./PoliticsList.vue?vue&type=script&lang=js&"
import style0 from "./PoliticsList.vue?vue&type=style&index=0&id=4510be06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4510be06",
  null
  
)

export default component.exports